import React from 'react'
import { some, find, get, filter, each } from 'lodash'
import Icon from 'UI/FontAwesomeIcon'

const assetHasSoftware = (asset, family, edition) => some(
  asset.software,
  software => software?.family === family && software?.edition === edition
)

const HasSoftwareCell = (family, edition) => ({
  accessor: (asset) => assetHasSoftware(asset, family, edition), width: 100,
  Cell: (value) => value.row[value.column.id] ? <Icon { ...{ icon: 'check', type: 'solid', text: '' }}/> : undefined
})
const UserSoftwareCell = (family, edition) => ({
  type: 'number', width: 100,
  accessor: (asset) => find(get(asset.software, edition), ['family', family])?.value
})

const oddColumnColor = '#EEE'
const sharedColumns = [
  {
    Header: 'SQL', columns: [
      { style: { backgroundColor: oddColumnColor }, Header: 'Enterprise', id: 'sql_enterprise', ...UserSoftwareCell('SQL', 'Enterprise') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Developer', id: 'sql_developer', ...UserSoftwareCell('SQL', 'Developer') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Standard', id: 'sql_standard', ...UserSoftwareCell('SQL', 'Standard') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Web', id: 'sql_web', ...UserSoftwareCell('SQL', 'Web') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Unknown', id: 'sql_unknown', ...UserSoftwareCell('SQL', 'Unknown') }
    ]
  },
  {
    Header: 'RDS', columns: [
      { Header: 'Servers', id: 'rds_servers', ...UserSoftwareCell('RDS', 'RDS') },
      { Header: 'Users', width: 100, accessor: 'total_users', type: 'number' },
      { Header: 'Logged On', width: 100, accessor: 'logged_on_users', type: 'number' }
    ]
  },
  {
    Header: 'Office', columns: [
      { style: { backgroundColor: oddColumnColor }, Header: 'Standard', id: 'standard_office', ...UserSoftwareCell('Office', 'Standard') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Professional', id: 'professional_office', ...UserSoftwareCell('Office', 'Professional') }
    ]
  },
  {
    Header: 'Visio', columns: [
      { Header: 'Standard', id: 'standard_visio', ...UserSoftwareCell('Visio', 'Standard') },
      { Header: 'Professional', id: 'professional_visio', ...UserSoftwareCell('Visio', 'Professional') }
    ]
  },
  {
    Header: 'Project', columns: [
      { style: { backgroundColor: oddColumnColor }, Header: 'Standard', id: 'standard_project', ...UserSoftwareCell('Project', 'Standard') },
      { style: { backgroundColor: oddColumnColor }, Header: 'Professional', id: 'professional_project', ...UserSoftwareCell('Project', 'Professional') }
    ]
  },
  {
    Header: 'Visual Studio', columns: [
      { Header: 'Professional', id: 'visual_studio_professional', ...UserSoftwareCell('Visual Studio', 'Professional') },
      { Header: 'Enterprise', id: 'visual_studio_enterprise', ...UserSoftwareCell('Visual Studio', 'Enterprise') }
    ]
  },
  {
    Header: 'Exchange', columns: [
      { style: { backgroundColor: oddColumnColor }, Header: 'Standard', width: 100, accessor: 'inDatto' },
      { style: { backgroundColor: oddColumnColor }, Header: 'Enterprise', width: 100, accessor: 'inDatto' }
    ]
  },
  {
    Header: 'Dynamics', columns: [
      { Header: 'CRM', id: 'dynamics_crm', ...HasSoftwareCell(/Microsoft Dynamics CRM/i) },
      { Header: 'GP', id: 'dynamics_gp', ...HasSoftwareCell(/Microsoft Dynamics GP/i) },
      { Header: 'NAV', id: 'dynamics_nav', ...HasSoftwareCell(/Microsoft Dynamics NAV/i) }
    ]
  },
  { Header: 'Sharepoint', columns: [{ style: { backgroundColor: oddColumnColor }, Header: 'Standard', id: 'standard_sharepoint', ...HasSoftwareCell(/Sharepoint/i) }] },
]

const customerColumns = [
  { Header: 'Name', accessor: 'short_name', width: 220 },
  { Header: 'Asset Count', accessor: ({ assets }) => assets.length, id: 'asset_count', type: 'number' },
  ...sharedColumns
]

const productColumns = [
  { Header: 'Name', accessor: 'name', width: 500 },
  { Header: 'Count', accessor: 'assets.length', width: 500, type: 'number' },
]

const assetColumns = (original) => {
  let splaColumns = []
  each([...original.family], (family) =>{
    if (family === 'Unknown') {
      splaColumns.push(...sharedColumns)
    } else {
      splaColumns.push(...filter(sharedColumns, ['Header', family]))
    }
  })

  return [
    { Header: 'Name', accessor: 'name', width: 400 },
    { Header: 'Operating System', accessor: 'operating_system', width: 400 },
    ...splaColumns
  ]
}

export { customerColumns, productColumns, assetColumns }
